<template>
<div>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Select Year" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select :loading="loading" return-object  item-text="name" single-line v-model="selectedYear" outlined :hide-details="yearErrors.length === 0" dense :error-messages="yearErrors" :items="years" label="Select Year"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" :disabled="!selectedYear" :dark="selectedYear ? true : false" @click="submit()">View Report Card </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showPdf" persistent max-width="750px">
    <v-card style="max-height:700px; overflow: hidden">
      <ModelTitle title="Report Card" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col id="section-to-print">
            <pdf style="height:550px" v-if="pdf" :src="pdf"></pdf>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" dark @click="printPDF()">Print </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import yearService from "@/modules/ReportCard/Year/service.js";
import classRoomService from "@/modules/ClassRoom/service.js";
import termService from "@/modules/ReportCard/Terms/service.js";
import subjectService from "@/modules/ReportCard/Subject/service.js";
import studentService from "@/modules/Students/service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
import pdfMake from 'pdfmake/build/pdfmake.min';
import { pdfMake as pdfFonts } from 'pdfmake/build/vfs_fonts';
import pdf from 'vue-pdf';

pdfMake.vfs = pdfFonts.vfs;
export default {
  name: 'generate-reportcard',
  props: {
    Dialog: {
      default: false,
    },
    Student: {
      type: Object,
    },
    selectedClassroom: {
      type: Object,
    },
  },
  data() {
    return {
      years: [],
      loading: false,
      dialog: false,
      YearId: null,
      selectedYear: null,
      doc: {
        content: []
      },
      classroom: [],
      students: [],
      grades: [],
      subjects: [],
      pdf: null,
      terms: [],
      termComment: [],
      classPosition: [],
      showPdf: false,
      reportCard: [],
      termCommentTable: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    YearId: {
      required,
    },
  },
  watch: {
    Dialog(val) {
      this.dialog = val;
      if (val) {
        this.getYear()
      }
    },
    selectedYear(val) {
      if(val)
        this.YearId = val.id
    }
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    yearErrors() {
      const errors = [];
      if (!this.$v.YearId.$dirty) return errors;
      if (!this.$v.YearId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  components: {
    pdf,
  },
  methods: {
    capitalizedText(val) {
      if(val)
        return val.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
      return null
    },
    getYear() {
      this.loading = true;
      if(this.Student.ClassStudents && this.Student.ClassStudents.length){
        let filteredClassIds=[]
        this.Student.ClassStudents.map(classes => {
          filteredClassIds.push(classes.ClassId)
        })
        yearService.getAll({filteredClasses: filteredClassIds}).then(response => {
          
          this.loading = false;
          this.years = response.data
        }).catch(error => {
          this.loading = false;
          console.log('error getting year', error)
        })
      }
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.YearId = null
      this.dialog = false
      this.years = [],
      this.loading = false,
      this.selectedYear = null,
      this.doc = {
        content: []
      },
      this.classroom = [],
      this.grades = [],
      this.subjects = [],
      this.pdf = null,
      this.terms = [],
      this.showPdf = false,
      this.reportCard = [],
      this.termComment = [],
      this.students = [],
      this.classPosition = [],
      this.termCommentTable = []
      this.$v.$reset();
    },
    getStudents(){
      return studentService.getStudentByClassRoomId({ClassRoomId: this.selectedClassroom.ClassRoomId}).then(response => {
        this.students = response.data
      }).catch(error => {
        console.log('error getting students', error)
      })
    },
    getClassroom(){
      return classRoomService.getById( this.selectedClassroom.ClassRoomId).then(response => {
        this.classroom = response.data
      }).catch(error => {
        console.log('error getting classRooms', error)
      })
    },
    getSubjects(){
      if(this.classroom.Curriculum && this.classroom.Curriculum.subjectMeta
      && this.classroom.Curriculum.subjectMeta.subjects){
        let subjectId = []
        this.classroom.Curriculum.subjectMeta.subjects.map(sub => {
          subjectId.push(sub.id)
        })
        return subjectService.getAll({filteredSubjects: subjectId}).then(response => {
          this.subjects = response.data
          if(this.subjects){
            this.classroom.Curriculum.subjectMeta.subjects.forEach(sub => {
              this.subjects.some(row => {
                if(row.id === sub.id) {
                  row.weightage = sub.marks
                }
              })
            });
          }
        }).catch(error => {
          console.log('error getting subjects', error)
        })
      }
    },
    getTerms(){
      return termService.getAll({
        YearId: this.YearId
      }).then(response => {
        this.terms = response.data
      }).catch(error => {
        console.log('error getting terms', error)
      })
    },
    getTermComments() {
      if(this.terms.length){
        let termsId = []
        this.terms.map(term => {
          termsId.push(term.id)
        })
        return studentService.termComments.getAll({
          filteredTerms: termsId,
          StudentId: this.Student.id
        }).then(response => {
          this.termComment = response.data
          if(this.termComment){
            let commentRows = []
            this.termCommentTable = []
            this.termComment.forEach((row) => {
              commentRows = []
              commentRows.push({ text: `${this.capitalizedText(row.Term.name)} Comments: `, bold: true, margin: [4, 10, 4, 10] });
              commentRows.push({ text: `${this.capitalizedText(row.comment)}`, margin: [4, 10, 4, 10] });
              this.termCommentTable.push(commentRows)
            })
          }
        }).catch(error => {
          console.log('error getting term comments', error)
        })
      }
    },
    getGrades() {
      let studentIds = []
      this.students.map(row => {
        studentIds.push(row.StudentId)
      })
      return studentService.grades.getAll({
        YearId: this.YearId,
        filteredStudents: studentIds,
        ClassroomId: this.classroom.id
      }).then(response => {
        this.grades = response.data
      }).catch(error => {
        console.log('error getting grade', error)
      })
    },
    mergeArrays(){
      this.reportCard = [];
      if(this.subjects && this.terms){
        const headerRow = [{ text: 'Subject', bold: true }];
        const secondRow = [{ text: 'Date', bold: true }];
        const ThirdRow = [{ text: '', bold: true }];
        const totalTermObtainedMarks = Array.from({ length: this.terms.length }, () => 0);
        const totalTermPercentageMarks = Array.from({ length: this.terms.length }, () => 0);
        this.terms.forEach((term) => {
          headerRow.push({ text: `${this.capitalizedText(term.name)}`, bold: true, colSpan: 2 });
          headerRow.push({});
          secondRow.push({ text: this.$moment(term.createdAt).format('MM/DD/YYYY') , bold: true, alignment: 'center', colSpan: 2 });
          secondRow.push({});
          ThirdRow.push({ text: 'Marks', bold: true });
          ThirdRow.push({ text: '%', bold: true, alignment: 'center' });
        });
        this.reportCard.push(headerRow);
        this.reportCard.push(secondRow);
        this.reportCard.push(ThirdRow);
        this.subjects.forEach((subject) => {
          const gradeRows = [ { text:`${subject.name}(${subject.weightage}%)`} ];

          this.terms.forEach((term, index) => {
            const grade = this.grades.find(
              (g) => g.SubjectId === subject.id && g.TermId === term.id && g.StudentId === this.Student.id
            );
            if(grade){
              gradeRows.push({text: `${parseFloat(grade.ObtainedMarks).toFixed(1)}`, alignment: 'center'})
              totalTermObtainedMarks[index] += parseFloat(grade.ObtainedMarks);
            }else{
              gradeRows.push({text: '', alignment: 'center'})
            }
            const weightedMarks = grade ? (parseFloat(grade.ObtainedMarks) / parseFloat(grade.totalMarks)) * parseFloat(subject.weightage) : 0;
            gradeRows.push({text: `${weightedMarks.toFixed(1)}%`, alignment: 'center'});
            totalTermPercentageMarks[index] += parseFloat(weightedMarks);
          });
          this.reportCard.push(gradeRows);
        });
        const totalRow = [{ text: 'Total', bold: true }];
        for (let i = 0; i < totalTermObtainedMarks.length; i++) {
          if(totalTermObtainedMarks[i])
            totalRow.push({ text: `${totalTermObtainedMarks[i].toFixed(1)}`, bold: true, alignment: 'center' });
          else
            totalRow.push({ text: '', bold: true, alignment: 'center' });
          totalRow.push({ text: `${totalTermPercentageMarks[i].toFixed(1)}%`, bold: true, alignment: 'center' });
        }
        this.reportCard.push(totalRow);
        const PositionRow = [{ text: 'Class Position', bold: true }];
        this.classPosition.map((position) => {
          PositionRow.push({ text: position, bold: true, alignment: 'center', colSpan: 2 });
          PositionRow.push({});
        })
        this.reportCard.push(PositionRow);
      }
    },
    findRank(){
      this.terms.map((term) => {
        const studentResults = this.students.map((student) => {

          const totalMarks = this.grades.reduce((total, grade) => {
            if (grade.StudentId === student.StudentId && grade.TermId === term.id) {
              const subjectWeightage = this.subjects.find((s) => s.id === grade.SubjectId);

              let termTotal = 0
              if(subjectWeightage)
                termTotal = (parseFloat(grade.ObtainedMarks) / parseFloat(grade.totalMarks)) * parseFloat(subjectWeightage.weightage);

              return total + termTotal;
            }
            return total;
          }, 0);

          return { student, totalMarks };
        });
        studentResults.sort((a, b) => b.totalMarks - a.totalMarks);
        this.classPosition.push(studentResults.findIndex((result) => result.student.StudentId === this.Student.id) + 1)
      })

    },
    async submit() {
      this.loading = true
      await this.getStudents()
      await this.getClassroom()
      await this.getSubjects()
      await this.getTerms()
      await this.getGrades()
      await this.getTermComments()
      await this.findRank()
      await this.mergeArrays()
      await this.createDocument()
      this.loading = false
    },
    printPDF(){
      window.print();
    },
    async createDocument(){
      this.doc.content = []
      this.doc.content.push({
        text: "Report Card",
        alignment: 'center',
        fontSize: 25,
        bold: true,
      });
      if (this.currentBusiness && this.currentBusiness.imageUrl) {
        try {
          const toDataURL = (url) =>
            fetch(url, { mode: 'cors' })
              .then((response) => response.blob())
              .then(
                (blob) =>
                  new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                  }),
              );

          const base64 = await toDataURL(this.currentBusiness.imageUrl).then(
            (dataUrl) => dataUrl,
          );
          this.doc.content.push({
            columns: [
              {
                stack: [
                  {
                    text: [
                      {text: `${this.currentBusiness.name}\n`, alignment: 'left', bold: true, fontSize: 20},
                      {text: `${this.currentBusiness.address}, ${this.currentBusiness.state} ${this.currentBusiness.zip}\n`, alignment: 'left'},
                      {text: `${this.currentBusiness.phoneNumber}\n`, alignment: 'left'},
                      {text: this.currentBusiness.email, alignment: 'left'},
                    ]
                  },
                ],
                margin: [0, 12, 0, 12],
              },
              {image: base64, alignment: 'right', width: 200, height: 100, margin: [0, 0, 0, 12]}
            ]
          })
        } catch (error) {
          console.log('image through error');
        }
      } else {
        this.doc.content.push({
          columns: [
            {
              stack: [
                {
                  text: [
                    {text: `${this.currentBusiness.name}\n`, alignment: 'left', bold: true, fontSize: 20},
                    {text: `${this.currentBusiness.address}, ${this.currentBusiness.state} ${this.currentBusiness.zip}\n`, alignment: 'left'},
                    {text: `${this.currentBusiness.phoneNumber}\n`, alignment: 'left'},
                    {text: this.currentBusiness.email, alignment: 'left'},
                  ]
                },
              ],
              margin: [0, 12, 0, 12],
            }
          ]
        })
      }
      this.doc.content.push({
        columns: [
          {text: "Name: " + this.Student.fullName, alignment: 'left', decoration: 'underline', margin: [0, 0, 0, 4]},
          {text: "Year: " + this.selectedYear.name, alignment: 'right', decoration: 'underline', margin: [0, 0, 0, 4]}
        ]
      })
      if(this.reportCard.length){
        this.doc.content.push({
          columns: [
            {text: "Class Position: " + this.classPosition[this.classPosition.length-1], alignment: 'left', decoration: 'underline', margin: [0, 0, 0, 4]},
            {text: this.selectedYear.note, alignment: 'right', margin: [0, 0, 0, 6]}
          ]
        })
      } else {
        this.doc.content.push({
          columns: [
            {text: "Grades will consider overall progress throughout the term.", alignment: 'right', margin: [0, 0, 0, 6]}
          ]
        })
      }
      if(this.subjects && this.terms){
        let borderStyle = {
          hLineWidth: function (i, node) {
            if (i === 0 || i === 1 || i === node.table.body.length - 1 || i === node.table.body.length) {
              return 2;
            }
            return 1;
          },
          vLineWidth: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return 2;
            }
            return 1;
          },
          hLineColor: function () {
            return 'black';
          },
          vLineColor: function () {
            return 'black';
          }
        };
        this.doc.content.push({
          table: {
            widths: '*',
            body: this.reportCard
          },
          layout: borderStyle
        })
        if(this.termComment.length) {
          this.doc.content.push({
            table: {
              widths: '*',
              body: this.termCommentTable
            },
            style: 'commentsTable'
          })
        }
      }
      this.doc.styles = {
        commentsTable: {
          margin: [0, 30, 0, 0]
        }
      }
      pdfMake.createPdf(this.doc).getDataUrl(data => {
        this.pdf = data;
      });
      this.dialog = false
      this.showPdf = true
    },
  }
}
</script>
<style scoped>
@media print {
  * {
    visibility: hidden;
    margin: 0;
    padding: 0;
  }

  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }

  #section-to-print {
    position: fixed;
    left: 0;
    top: 0;
  }
}
</style>